let html = `<div class="card-watched">
    <div class="card-watched__inner">
        <div class="card-watched__body"></div>
    </div>
</div>`

export default html